import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Modal } from 'react-bootstrap';

import { bulkRemoveTasks, endBulkRemoveTasks } from './store/actions/tasks';

export class CallBulkRemoveModal extends React.Component {
  static propTypes = {
    bulkRemoveTasks: PropTypes.bool.isRequired,
    selectedTaskIds: PropTypes.array.isRequired,
    onBulkRemoveTasks: PropTypes.func.isRequired,
    onCancelBulkRemoveTasks: PropTypes.func.isRequired
  };

  render() {
    const { bulkRemoveTasks, selectedTaskIds, onCancelBulkRemoveTasks, onBulkRemoveTasks } = this.props;
    const entityCount = selectedTaskIds.length;

    return (
      <Modal show={bulkRemoveTasks} onHide={onCancelBulkRemoveTasks}>
        <Modal.Header closeButton>
          <Modal.Title>Bulk Removal</Modal.Title>
        </Modal.Header>
        <Modal.Body className="left-buffer-md">
          <div className="bottom-buffer-sm">You are about to remove <strong>{entityCount} Calls</strong></div>
          <div className="top-buffer-sm">Are you sure you want to remove them?</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-sm btn-cancel' onClick={onCancelBulkRemoveTasks}>Cancel</button>
          <button className='btn btn-sm btn-danger' onClick={onBulkRemoveTasks}>Remove Calls</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  bulkRemoveTasks: state.tasks.startBulkRemoveTasks,
  selectedTaskIds: state.selectList.selectedTaskIds
});

const mapDispatchToProps = {
  onBulkRemoveTasks: bulkRemoveTasks,
  onCancelBulkRemoveTasks: endBulkRemoveTasks
};

export default connect(mapStateToProps, mapDispatchToProps)(CallBulkRemoveModal);
